import api from '../helpers/api.service'
import endpoints from '../models/api/api.endpoints'
import Helper from '../helpers/helper.service'
import ServiceResponseCode from '../models/service.response.code'
import { resolveTheme } from '../helpers/resolveTheme'

export default {
  async list(pageSize = null, pesquisa = null, theme = resolveTheme()) {
    const params = [
      { Name: 'theme', Value: theme },
      { Name: 'pageSize', Value: pageSize },
      { Name: 'pesquisa', Value: pesquisa },
    ]
    try {
      const url = `${endpoints.contato}/list${Helper.getURLParams(params)}`
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async listCadastro(page = null, pageSize = null, pesquisa = null, modalidade = null) {
    const params = [
      { Name: 'page', Value: page },
      { Name: 'pageSize', Value: pageSize },
      { Name: 'pesquisa', Value: pesquisa },
      { Name: 'modalidade', Value: modalidade },
    ]
    try {
      const url = `${endpoints.contato}/list-cadastro${Helper.getURLParams(params)}`
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async incluir(data) {
    try {
      const result = await api.post(endpoints.contato, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async atualizar(data) {
    try {
      const result = await api.put(endpoints.contato, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async excluir(id) {
    try {
      const result = await api.delete(`${endpoints.contato}/${id}`)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
}
